// components
import Header from "./Header";
import Table from "./Tables";

export default function App() {
  return (
    <main className="container mx-auto h-screen capitalize">
      <div>
        <Header />
        <Table />
      </div>
    </main>
  );
}
